export default function TimeFilter(value, format = 'HH:mm') {
    if (value) {
        return moment(value).format(format);
    }
}
